import { Component, OnInit, Input, ChangeDetectionStrategy} from '@angular/core';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

@Component({ standalone: false,
  selector: 'irb-panel-button',
  templateUrl: './panel-button.component.html',
  styleUrls: ['./panel-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class PanelButtonComponent implements OnInit {
  @Input() label: string;
  @Input() isTall: boolean = false;
  @Input() isDisabled: boolean = false;
  @Input() faChevronRight = faChevronRight;
  @Input() supressIcon :boolean = false;
    @Input() noMaxHeight: boolean = false;


  
  constructor() { }

  ngOnInit() {
  }
}
